import { ReadOnlyDoc } from "./ReadOnlyDoc";

export default ReadOnlyDoc;
